import { render, staticRenderFns } from "./leftImg.vue?vue&type=template&id=0856f8d8&scoped=true&"
import script from "./leftImg.vue?vue&type=script&lang=js&"
export * from "./leftImg.vue?vue&type=script&lang=js&"
import style0 from "./leftImg.vue?vue&type=style&index=0&id=0856f8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856f8d8",
  null
  
)

export default component.exports